// Typewriter.js
import React, { useState, useEffect } from "react";
import { marked } from "marked";

export default function Typewriter({ rawText, speed = 40, style, onComplete, onProgress }) {
  const [displayed, setDisplayed] = useState("");

  useEffect(() => {
    let i = 0;
    setDisplayed("");

    const timer = setInterval(() => {
      i++;
      setDisplayed(rawText.slice(0, i));

      // 👇 Call scroll handler after each character
      if (onProgress) onProgress();

      if (i >= rawText.length) {
        clearInterval(timer);
        onComplete?.(); // signal we're done
      }
    }, speed);

    return () => clearInterval(timer);
  }, [rawText, speed, onComplete, onProgress]);

  const html = marked.parse(displayed);
  return <div style={style} dangerouslySetInnerHTML={{ __html: html }} />;
}
